<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <loader :loading="loadingCategories"/>

    <form-group :label="$t('category.label')" :columns="5" :error="getError('category', product.productId)" :required="true">
      <multiselect
        v-model="category"
        :options="categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
        label="label"
        track-by="code"
      />
    </form-group>

  </shared-product-provide>
</template>

<script>
  import { AllHtmlEntities } from 'html-entities'
  import { mapActions, mapGetters } from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'
  import notifier from '@/notifier'
  import { cloneDeep } from 'lodash'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'leroy'
      },
      maxDescriptionLengthDI: 280,
      allowDescriptionHtml: false
    },
    data: () => ({
      loadingCategories: false,
      categories: [],
      category: null
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.loadingCategories = true

      api.getCategories('marketplace', 'leroy')
        .then(category => {
          this.categories = category
          this.product.category = ''

          const presetCategorization = this.$parent.getPresetItemsCategorization(this.product.categories)
          if (presetCategorization !== null && presetCategorization !== undefined) {
            this.category = this.categories.find(category => category.code === presetCategorization.category)
          }
        })
        .catch(() => {
          notifier.error('Impossível carregar as categorias da Leroy Merlin.', 'Erro')
        })
        .finally(() => {
          this.loadingCategories = false
        })
      this.$parent.loadingProducts(false)
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      formatProduct () {
        this.clearErrors()

        this.product.variations.map(variation => {
          if (variation.leroyAttributes !== undefined) {
            variation.leroyAttributes
              .map(attribute => {
                if ((attribute.value === null || attribute.value === undefined || attribute.value === '') && attribute.required) {
                  this.addError({
                    productId: this.product.productId,
                    property: attribute.code,
                    sku: variation.sku,
                    error: {
                      message: 'required',
                      value: 1
                    }
                  })
                }
              })
          }
        })

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            let attributes = []
            if (variation.leroyAttributes !== undefined) {
              attributes = cloneDeep(variation.leroyAttributes)
                .filter(attribute => attribute.value !== undefined && attribute.value !== 'undefined')
                .map(attribute => {
                  if (attribute.type === 'DECIMAL') {
                    attribute.value = parseFloat(attribute.value.replace(',', '.'))
                  }

                  return {
                    id: attribute.code,
                    label: attribute.label,
                    valueId: attribute.value,
                    valueLabel: attribute.value
                  }
                })
            }

            return {
              sku: variation.sku,
              attributes: attributes,
              title: this.product.title,
              description: this.product.description,
              stock: variation.stock,
              price: variation.price,
              source: this.fromModule,
              ean: variation.ean,
              images: variation.images.length ? variation.images : null,
              width: variation.width,
              height: variation.height,
              weight: variation.weight,
              length: variation.length,
              category: this.category ? this.category.code : null,
              brand: this.product.brand,
              productId: this.product.productId,
              crossDocking: {
                quantity: variation.crossDocking
              },
              original: {
                product: this.product,
                variation: variation
              }
            }
          }
        )
      },
      getAttributes (categoryCode) {
        this.loadingCategories = true

        api.leroy.getAttributes(categoryCode)
          .then(attribute => {
            const attributeClone = cloneDeep(attribute)

            for (let i in attributeClone) {
              const attr = attributeClone[i]

              if (attr.label === 'Observações sobre a Garantia do Fabricante' && this.product.warranty) {
                attr.value = this.removeHtml(this.product.warranty)
              }
            }

            this.product.variations.forEach(variation => (this.$set(variation, 'leroyAttributes', cloneDeep(attributeClone))))
          })
          .catch(() => {
            notifier.error('Impossível carregar os atributos da Leroy Merlin.', 'Erro')
          })
          .finally(() => {
            this.loadingCategories = false
          })
      },
      removeHtml (string) {
        const find = ['&Aacute;', '&aacute;', '&Acirc;', '&acirc;', '&Agrave;', '&agrave;', '&Aring;', '&aring;', '&Atilde;', '&atilde;', '&Auml;', '&auml;', '&AElig;', '&aelig;', '&Eacute;', '&eacute;', '&Ecirc;', '&ecirc;', '&Egrave;', '&egrave;', '&Euml;', '&euml;', '&ETH;', '&eth;', '&Iacute;', '&iacute;', '&Icirc;', '&icirc;', '&Igrave;', '&igrave;', '&Iuml;', '&iuml;', '&Oacute;', '&oacute;', '&Ocirc;', '&ocirc;', '&Ograve;', '&ograve;', '&Oslash;', '&oslash;', '&Otilde;', '&otilde;', '&Ouml;', '&ouml;', '&Uacute;', '&uacute;', '&Ucirc;', '&ucirc;', '&Ugrave;', '&ugrave;', '&Uuml;', '&uuml;', '&Ccedil;', '&ccedil;', '&Ntilde;', '&ntilde;', '&lt;', '&gt;', '&amp;', '&reg;;', '&copy;;', '&Yacute;', '&yacute;', '&THORN;', '&thorn;', '&szlig;', '&quot;', '&nbsp;']
        const replace = ['Á', 'á', 'Â', 'â', 'À', 'à', 'Å', 'å', 'Ã', 'ã', 'Ä', 'ä', 'Æ', 'æ', 'É', 'é', 'Ê', 'ê', 'È', 'è', 'Ë', 'ë', 'Ð', 'ð', 'Í', 'í', 'Î', 'î', 'Ì', 'ì', 'Ï', 'ï', 'Ó', 'ó', 'Ô', 'ô', 'Ò', 'ò', 'Ø', 'ø', 'Õ', 'õ', 'Ö', 'ö', 'Ú', 'ú', 'Û', 'û', 'Ù', 'ù', 'Ü', 'ü', 'Ç', 'ç', 'Ñ', 'ñ', '<', '>', '&', '®', '©', 'Ý', 'ý', 'Þ', 'þ', 'ß', '\\"', ' ']

        for (let i in find) {
          const f = find[i]
          string = string.replace(new RegExp(f, 'g'), replace[i])
        }

        string = string
          .replace(/<p>/g, '')
          .replace(/<\/p>|<br>|<br \/>|<br\/>/g, `\n`)
          .replace(/(<([^>]+)>)/ig, '')

        return AllHtmlEntities.decode(string)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError',
        'getErrors'
      ])
    },
    watch: {
      category (value) {
        this.getAttributes(value.code)
      }
    },
    components: {
      SharedProductProvide,
      FormGroup,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?a3f7e19a